<template>
  <div class="page-content-sidebar-list-group-collapsible">
    <tm-expansion-item
      class="tm-expansion-item--menu"
      :model-value="opened"
      :header-style="expansionItemHeaderStyle"
      :disable="isCollapsingDisabled"
      @update:model-value="$emit('update:opened', $event)"
    >
      <template v-slot:header>
        <div class="q-item__section q-item__section--main">
          <page-content-sidebar-list-title
            class="tm-expansion-item--menu__title"
            :title="title"
          >
            <template v-slot:title>
              <slot name="title" />
            </template>
          </page-content-sidebar-list-title>
        </div>
      </template>
      <slot class="pb-4" />
    </tm-expansion-item>
    <hr
      v-if="!opened && !hideCollapsedHr"
      class="page-content-sidebar-list-group-collapsible__hr"
    />
  </div>
</template>

<script setup lang="ts">
import type { VueStyleProp } from 'quasar'
import PageContentSidebarListTitle from '@/components/layout/pageContent/sidebar/sidebarItem/PageContentSidebarListTitle.vue'
import TmExpansionItem from '@/components/shared/TmExpansionItem.vue'
import { computed } from '@/composition/vue/compositionApi'

const props = defineProps<{
  opened: boolean
  title: string
  toggleIconFontSize?: number
  isCollapsingDisabled?: boolean
  hideCollapsedHr?: boolean
}>()

defineEmits<{
  'update:opened': [boolean]
}>()

const expansionItemHeaderStyle = computed<VueStyleProp>(() => {
  return {
    padding: '0',
    minHeight: '0',
  }
})

const tmExpansionItemToggleIconFontSize = computed(() => {
  return props.toggleIconFontSize ? `${props.toggleIconFontSize}px` : '20px'
})
</script>

<style lang="scss" scoped>
.page-content-sidebar-list-group-collapsible {
  .tm-expansion-item--menu {
    --tm-expansion-item-toggle-width: 32px;
    --tm-expansion-item-toggle-height: 32px;
    --tm-expansion-item-toggle-icon-font-size: v-bind(tmExpansionItemToggleIconFontSize);
    --tm-expansion-item-toggle-icon-color: #{$gray6};
    --tm-expansion-item-section--side-padding-right: #{$pageContentSidebarListGroupCollapsiblePaddingRight};

    padding-top: var(--page-content-sidebar-list-group-collapsible-offset-y, 16px);
    padding-bottom: var(--page-content-sidebar-list-group-collapsible-offset-y, 16px);
    border-bottom: none;

    .page-content-sidebar-list-title {
      margin-top: 0;
    }

    &__title {
      cursor: pointer;
    }
  }

  &__hr {
    background: $gray2;
    margin: 0 16px;
  }
}
</style>
